class LabModalTrigger extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', '0');
    }

    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'button');
    }

    this.target = this.getAttribute('data-target');
  }

  connectedCallback() {
    if (!this.target) return;

    this.modal = document.querySelector(`lab-modal#${this.target}`);

    if (!this.modal) return;

    this.setAttribute('aria-controls', this.target);

    this.initTrigger();
  }

  initTrigger() {
    this.addEventListener('keydown', this.handleKeyDown);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.handleKeyDown);
    this.removeEventListener('click', this.handleClick);
  }

  toggleModalVisibility() {
    const isModalOpen = this.modal.hasAttribute('open');

    this.modal.toggleAttribute('open', !isModalOpen);
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.click();
    }
  }

  handleClick() {
    this.toggleModalVisibility();
  }
}

if (!customElements.get('lab-modal-trigger')) {
  customElements.define('lab-modal-trigger', LabModalTrigger);
}